"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SCATTER_CHART_PRO_PLUGINS = void 0;
var _internals = require("@mui/x-charts/internals");
var _useChartProExport = require("../internals/plugins/useChartProExport");
var _useChartProZoom = require("../internals/plugins/useChartProZoom");
const SCATTER_CHART_PRO_PLUGINS = exports.SCATTER_CHART_PRO_PLUGINS = [_internals.useChartZAxis, _internals.useChartCartesianAxis, _internals.useChartInteraction, _internals.useChartHighlight, _internals.useChartVoronoi, _useChartProZoom.useChartProZoom, _useChartProExport.useChartProExport];